import { SettingsBackupRestore as SettingsBackupRestoreIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useCanReset } from '../../../stores/TimeRangeHistoryStore';
import { useTimeRangeNavigation } from '../../../utilities/TimeRangeNavigationUtilities';

export default function ResetAction(props) {
    const [canReset] = useCanReset();
    const { enabled, reset } = useTimeRangeNavigation();

    return enabled ? (
        <Action
            icon={<SettingsBackupRestoreIcon />}
            tooltip={t`Reset the time range`}
            disabled={!canReset}
            onClick={reset}
            {...props}
        />
    ) : null;
}
